import React, {memo} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
import {colors, fontSize, fontWeight} from '@/styles/tokens';
import type {closingContent} from '@/util/contents/drawpost-data';

interface ClosingSectionProps {
    heading: string;
    content: typeof closingContent;
}

const sectionSx = {
    bgcolor: colors.background.subtle
} as const;

const paraTextSx = {
    color: colors.text.primary,
    fontSize: fontSize[16],
    textAlign: 'center',
    mt: 3
} as const;

const ClosingSection = memo(function ClosingSection({heading, content}: ClosingSectionProps) {
    return (
        <Box className="top-space bottom-spacing mobile-top-padding mobile-padding-bottom" sx={sectionSx}>
            <MUIContainer>
                <Box textAlign="center" maxWidth={1024} margin="0 auto">
                    <Typography variant="h1" component="h2" fontSize={{xs: 35, sm: 48}} className="font-headers">
                        {heading}
                    </Typography>

                    <Typography sx={paraTextSx} className="font-regular-text remove-underline">
                        {content.paragraphs[0]}
                    </Typography>

                    <Typography sx={paraTextSx} className="font-regular-text remove-underline">
                        {content.paragraphs[1]}
                        <Box component="strong" sx={{fontWeight: fontWeight.bold, color: colors.text.primary}}>
                            {content.paragraphHighlight}
                        </Box>
                        {content.paragraphSuffix}
                    </Typography>
                </Box>
            </MUIContainer>
        </Box>
    );
});

export default ClosingSection;
